import { ZfBox, ZfIconButton, ZfStack, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserDetails } from '../../../api';
import type { TalkingPointDto } from '../../../api/generated/client';

interface IProps {
    point: TalkingPointDto;
    onDelete?: () => void;
    onTalkingPointClick?: (talkingPoint: TalkingPointDto) => void;
}

export const TalkingPointListItem: FunctionComponent<IProps> = ({ point, onDelete, onTalkingPointClick }) => {
    const { i18n } = useTranslation();

    const { data: user } = useUserDetails();

    return (
        <ZfBox className="talking-point-list-item" onClick={() => onTalkingPointClick?.(point)}>
            <ZfStack direction="row" alignment="center" justify="space-between">
                <ZfTypography variant="body-large" style={{ flex: 1, paddingRight: 'var(--padding-right-xxl)' }}>
                    {point.name[i18n.language]}
                </ZfTypography>
                {user?.currentRole === 'CONTENT' && <ZfIconButton icon="delete" onClick={onDelete} hierarchy="tertiary" size="large" />}
            </ZfStack>
        </ZfBox>
    );
};
